<mat-list *ngFor="let day of this.getClassNumbers()">
    <div mat-subheader class="subhead">Day {{day}}</div>
    <mat-list-item *ngFor="let item of this.filterTiming(day)">
        <mat-icon matListItemIcon class="icon">schedule</mat-icon>
        <div matListItemTitle class="title">{{this.getDay(item.day)}}</div>
        <div matListItemLine class="line">{{this.getTime(item.time)}}</div>
    </mat-list-item>
</mat-list>
<mat-divider></mat-divider>